import type { CommonSVGProps } from './helpers';

export const Signature = (props: CommonSVGProps) => (
  <svg fill="none" height="182" viewBox="0 0 174 182" width="174" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g id="Frame 1538227893">
      <path
        d="M46.3627 39.173C46.8302 60.0556 51.0181 81.332 48.7962 102.191C47.634 113.101 44.1713 124.407 38.4829 133.845C33.4487 142.198 21.686 154.751 10.4245 148.384C3.40202 144.413 4.73521 133.662 5.71447 127.456C8.33497 110.848 15.2794 94.3316 25.0003 80.6415C33.3642 68.8624 44.6765 57.327 57.0399 49.7121C61.4064 47.0227 69.6829 43.7227 70.6254 51.6902C72.1851 64.8746 55.3948 76.1045 46.2872 82.7703C45.6451 83.2402 43.5941 84.4495 44.3186 84.1204C50.9552 81.1061 58.4316 79.0475 65.5649 77.7665C75.5978 75.9649 111.887 74.2654 103.798 94.4265C98.1032 108.619 84.9925 116.697 70.2905 118.964C61.5998 120.304 49.3067 119.707 40.4899 118.724C11.6474 115.51 43.6899 118.766 28.4819 116.002"
        id="Vector 20"
        stroke="#032B49"
        strokeLinecap="round"
        strokeWidth="2.66134"
      />
      <path
        d="M89.0695 67.1038C88.3383 69.9462 82.4851 82.6743 88.876 82.9004C92.5885 83.0318 95.595 80.5111 98.39 78.4444"
        id="Vector 21"
        stroke="#032B49"
        strokeLinecap="round"
        strokeWidth="2.66134"
      />
      <path
        d="M92.2497 54.7425C92.9967 53.586 94.7118 52.7148 95.807 51.8921"
        id="Vector 22"
        stroke="#032B49"
        strokeLinecap="round"
        strokeWidth="2.66134"
      />
      <path
        d="M94.9447 97.3268C102.732 92.4098 108.87 84.7913 113.706 77.0499C122.463 63.0323 128.244 45.8894 129.981 29.4353C130.187 27.4894 131.23 24.6292 129.579 23.579C129.186 23.3288 128.559 23.6509 128.243 23.9937C126.258 26.1472 123.714 32.0011 122.978 34.0926C117.235 50.416 115.859 69.0094 120.071 85.852C120.902 89.1767 122.732 96.8728 127.519 97.0509C134.726 97.3191 139.082 86.3023 141.206 81.3523C146.663 68.6379 152.091 54.4515 153.651 40.5971C154.385 34.082 153.696 36.3309 153.721 38.497C153.955 58.7652 155.965 78.9623 157.067 99.1868"
        id="Vector 23"
        stroke="#032B49"
        strokeLinecap="round"
        strokeWidth="2.66134"
      />
    </g>
  </svg>
);
